import { child, onValue, ref, remove, set, update } from 'firebase/database';
import { useEffect, useState } from 'react';

import objectToArray from '../../utils/objectToArray';
import { database, auth } from '../config';
import { IBoard } from './typings';
import generateId from '../../utils/generateID';

const databaseRef = ref(database);

export const usePrivateBoards = () => {
  const [boards, setNewBoard] = useState<IBoard[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const privateBoardsUrl = `private/${auth.currentUser?.uid}/boards`;

  useEffect(() => {
    onValue(child(databaseRef, privateBoardsUrl), (snap) => {
      setNewBoard(objectToArray(snap?.val()));
      setLoading(false);
    });
  }, []);

  return { boards, loading };
};

export const createBoard = async (name: string) => {
  try {
    const created = new Date().toISOString();
    const id = generateId();

    const data = {
      id,
      created,
      name,
    };

    const privateBoardsUrl = `private/${auth.currentUser?.uid}/boards`;

    await set(child(databaseRef, `${privateBoardsUrl}/${id}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateBoard = async (id: string, name: string) => {
  try {
    const data = {
      name,
    };

    const privateBoardsUrl = `private/${auth.currentUser?.uid}/boards`;

    await update(child(databaseRef, `${privateBoardsUrl}/${id}`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const deleteBoard = async (id: string) => {
  const privateBoardsUrl = `private/${auth.currentUser?.uid}/boards`;

  try {
    await remove(child(databaseRef, `${privateBoardsUrl}/${id}`));
  } catch (e) {
    console.log(e);
    throw e;
  }
};
